import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoTreeViewMixin from './KendoTreeViewMixin'

export default {
    name: 'kendo-treeview',
    mixins: [ KendoTreeViewMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        const defaultSlot = (this.v3 && this.$slots.default && (typeof this.$slots.default === 'function')) ? this.$slots.default() : this.$slots.default
        return h('ul', defaultSlot)
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-treeview-vue-wrapper/src/KendoTreeView/index.js